import { Link } from "react-router-dom";

const Logo = () => {
  return (
    <div className="flex-shrink-0">
      <Link to="/" className="block">
        <img
          src="/logos/horizontal.png"
          alt="Property Vue Logo"
          className="h-12 md:h-14 w-auto object-contain"
          loading="eager"
          decoding="async"
          fetchPriority="high"
          onError={(e) => {
            console.error('Error loading logo image');
            e.currentTarget.src = "/placeholder.svg";
          }}
        />
      </Link>
    </div>
  );
};

export default Logo;